import Vue from 'vue';
import { map } from 'lodash';
import * as types from './mutation-types';

const mutations = {

  [types.SET_CAT_SUBJECT](state, catSubjects) {
    const result = map(catSubjects, item => (
      {
        subject_id: item.id,
        subject_name: item.name,
        icon_url: item.icon_url,
        color_code: item.color_code,
      }
    ));

    Vue.set(state, 'catSubjects', result);
  },

  [types.SET_CAT_DOMAIN](state, catDomains) {
    Vue.set(state, 'catDomains', catDomains);
  },

  [types.SET_ACTIVE_ASSIGNMENT](state, activeAssignments) {
    Vue.set(state, 'activeAssignments', activeAssignments);
  },

  [types.SET_CAT_CONFIGS](state, catConfigs) {
    Vue.set(state, 'catConfigs', catConfigs);
  },

  [types.SET_PROFICIENCY_HISTORY](state, proficiencyHistory) {
    Vue.set(state, 'proficiencyHistory', proficiencyHistory);
  },

  [types.SET_FILTER_PROFICIENCY_HISTORY](state, { subjectId, proficiencyHistory }) {
    Vue.set(state.filterProficiencyHistory, subjectId, proficiencyHistory);
  },

  [types.SET_FILTER_PROFICIENCY_RANK](state, { subjectId, proficiencyRank }) {
    Vue.set(state.filterProficiencyRank, subjectId, proficiencyRank);
  },

  [types.SET_BUSY](state, busy) {
    Vue.set(state, 'busy', busy);
  },

  [types.SET_SELECTED_SUBJECT_ID](state, subjectId) {
    Vue.set(state, 'selectedSubjectId', subjectId);
  },

  [types.SET_CHILD_PROFICIENCY_HISTORY](state, { childId, subjectId, proficiencyHistory }) {
    if (!state.childProficiencyHistory[childId]) {
      Vue.set(state.childProficiencyHistory, childId, {});
    }

    Vue.set(state.childProficiencyHistory[childId], subjectId, proficiencyHistory);
  },

  [types.SET_CHILD_PROFICIENCY_RANK](state, { childId, subjectId, proficiencyRank }) {
    if (!state.childProficiencyRank[childId]) {
      Vue.set(state.childProficiencyRank, childId, {});
    }

    Vue.set(state.childProficiencyRank[childId], subjectId, proficiencyRank);
  },

  [types.SET_SELECTED_CHILD](state, selectedChild) {
    Vue.set(state, 'selectedChild', selectedChild);
  },

  [types.SET_SELECTED_LECTURE_SUBJECT_ID](state, selectedLectureSubjectId) {
    Vue.set(state, 'selectedLectureSubjectId', selectedLectureSubjectId);
  },

  [types.SET_VIDEO_LECTURES](state, { videoLectures, subjectId }) {
    if (!state.filterVideoLectures[subjectId]) {
      Vue.set(state.filterVideoLectures, subjectId, []);
    }

    if (!state.filterVideoLecturesPosition[subjectId]) {
      Vue.set(state.filterVideoLecturesPosition, subjectId, 1);
    }

    const videoPosition = Number(state.filterVideoLecturesPosition[subjectId] + 1);
    const videoLecturesConcat = state.filterVideoLectures[subjectId].concat(videoLectures);
    Vue.set(state.filterVideoLecturesPosition, subjectId, videoPosition);
    Vue.set(state.filterVideoLectures, subjectId, videoLecturesConcat);
  },

  [types.SET_CARD_LECTURES](state, { cardLectures, subjectId }) {
    if (!state.filterCardLectures[subjectId]) {
      Vue.set(state.filterCardLectures, subjectId, []);
    }

    if (!state.filterCardLecturesPosition[subjectId]) {
      Vue.set(state.filterCardLecturesPosition, subjectId, 1);
    }

    const cardPosition = Number(state.filterCardLecturesPosition[subjectId] + 1);
    const cardLecturesConcat = state.filterCardLectures[subjectId].concat(cardLectures);
    Vue.set(state.filterCardLecturesPosition, subjectId, cardPosition);
    Vue.set(state.filterCardLectures, subjectId, cardLecturesConcat);
  },

  [types.SET_SUBJECTS](state, subjects) {
    Vue.set(state, 'subjectMap', subjects);
  },

  [types.SET_RECOMMEND_VIDEO_LECTURES](state, videoLectures) {
    Vue.set(state, 'recommendVideoLectures', videoLectures);
  },

  [types.SET_RECOMMEND_CARD_LECTURES](state, cardLectures) {
    Vue.set(state, 'recommendCardLectures', cardLectures);
  },

  [types.SET_BUSY](state, busy) {
    Vue.set(state, 'busy', busy);
  },

};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/cat-main/store/mutations.js